import React from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import logo from './assets/logo.png'; // Tu logo
import './slider.css';
import 'typeface-roboto'; // Esto es un ejemplo, puedes elegir la tipografía que prefieras
import carta_abril from './assets/carta_ene-feb.pdf'
const styles = {
	slider: {
		height: '100vh',
	},
	slide: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		height: '100vh',
		color: '#fff',
		textAlign: 'center',
	},
	header: {
		fontSize: '3vh', // Ajustar según necesidad
		fontFamily: 'SansitaSwashed', // Asegúrate de cargar la fuente que elijas
		margin: '2vh 0',
	},
	text: {
		fontSize: '2vh', // Ajustar según necesidad
		fontFamily: 'SansitaSwashed',
	},
	text2: {
		fontSize: '2vh', // Ajustar según necesidad
		fontFamily: 'SansitaSwashed',
	},
	logo: {
		maxHeight: '30vh', // Altura máxima para el logo
		margin: '4vh 0',
	},
	logoChico: {
		maxHeight: '15vh', // Altura máxima para el logo
		margin: '1vh 0',
	},
	iframeMap: {
		border: '0',
		borderRadius: '1vh', // Bordes redondeados
		width: '100%', // Ocupa todo el ancho disponible
		height: '50vh', // Ajustar según necesidad
		boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', // Sombra para dar profundidad
	},
	button: {
		marginTop: '50px !important', // Aumenta el espacio sobre el botón
		fontSize: '25px', 
	},
	buttonLink: {
		display: 'inline-block', // Esto permite aplicar padding y margin como en un botón
		textDecoration: 'none', // Quitar el subrayado del enlace
		textAlign: 'center', // Centrar texto dentro del "botón"
		// Otros estilos específicos que necesites
	  }
};

const Slider = ({startIndex }) => (
	<AwesomeSlider selected={startIndex} style={styles.slider} bullets={false}>
	<div
		style={{ ...styles.slide, backgroundColor: '#E44B25', padding: '0 20px' }}
		className='slide'
	>
		<img
			src={logo}
			alt='Logo del restaurante napolitano'
			style={{ ...styles.logo, margin: '0 auto', display: 'block' }}
		/>
		<h2 style={{ ...styles.header, fontSize: 'larger', textAlign: 'center' }}>
			¡Ya puedes pedir online!
		</h2>
		<p
			style={{
				...styles.text,
				fontSize: 'larger',
				textAlign: 'center',
				marginTop: '20px',
			}}
		>
			<strong>
				La revolución del sabor napolitano está al alcance de tu mano.
			</strong>
			<br />
		</p>
		<a           style={{
            ...styles.buttonLink,
            backgroundColor: '#64A242',
            color: 'white',
            padding: '15px 30px',
			marginTop: '100px !important',
            fontSize: '25px',
            borderRadius: '5px',
            textDecoration: 'none',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
            transition: 'background-color 0.3s ease',
          }} href="https://www.shefri.com">
			¡Pedir Ahora!
		</a>
	</div>





		<div style={{ ...styles.slide, backgroundColor: '#E44B25' }} className='slide'>
      <img src={logo} alt='Logo del restaurante' style={styles.logoChico} />
      <h2 style={styles.header}>Una Experiencia Gastronómica Inolvidable</h2>
      <p style={styles.text}>
        Imagina un bocado perfecto, el equilibrio justo entre la tradición y la creatividad, la cocina que habla historias de lugares lejanos y tiempos remotos. Eso es lo que te espera en nuestra carta.
      </p>
      <p style={styles.text}>
        Cada plato es una promesa de placer, un viaje culinario que estamos ansiosos de compartir contigo. ¿Listo para descubrir tu nuevo favorito?
      </p>
      <div style={{ textAlign: 'center', margin: '20px 20px' }}>
        <a
          href={carta_abril} // Cambia esto por la URL real donde tu PDF es accesible
          target="_blank" // Esto asegura que el PDF se abra en una nueva pestaña
          rel="noopener noreferrer" // Por seguridad y rendimiento
          style={{
            ...styles.buttonLink,
            backgroundColor: '#64A242',
            color: 'white',
            padding: '15px 30px',
			marginTop: '100px !important',
            fontSize: '25px',
            borderRadius: '5px',
            textDecoration: 'none',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
            transition: 'background-color 0.3s ease',
          }}
        >
          Ver Menú
        </a>
      </div>
    </div>






		<div
			style={{ ...styles.slide, backgroundColor: '#E44B25' }}
			className='slide'
		>
			<img
				src={logo}
				alt='Logo del restaurante napolitano'
				style={styles.logoChico}
			/>
			<>
				<h2 style={styles.header}>Explora, Saborea, Disfruta</h2>
				<p style={styles.text2}>
					Sumérgete en el ambiente acogedor de nuestro restaurante o invita el
					sabor a tu mesa con nuestro servicio de entrega.
					<br />
					¡Tu próxima gran comida está a solo un click!
				</p>
			</>
			<iframe
				title='Ubicación de Shefri Sabor Napolitano'
				src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.1600149554024!2d-68.58238382503662!3d-31.519764801255317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9681413c9e05fc87%3A0x764b8284b0a4a59!2sShefri%20sabor%20napolitano!5e0!3m2!1sen!2sar!4v1699213358735!5m2!1sen!2sar'
				width='100%'
				height='300'
				style={{
					borderRadius: '10px',
					border: '0',
					marginBottom: '20px',
					marginRight: '100px',
				}}
				allowFullScreen
				loading='lazy'
				referrerPolicy='no-referrer-when-downgrade'
			></iframe>
			<div style={{ textAlign: 'center', margin: '20px 0' }}>
				<a
					href='https://wa.me/2645141313'
					style={{
						...styles.ctaButton,
						display: 'inline-block',
						backgroundColor: '#64A242',
						color: 'white',
						padding: '15px 30px',
						fontSize: '18px',
						borderRadius: '5px',
						boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
						textDecoration: 'none',
						transition: 'background-color 0.3s ease',
					}}
				>
					Pedí por WhatsApp - Fácil y Rápido
				</a>
			</div>
		</div>
	</AwesomeSlider>
);

export default Slider;
